var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "contenitore",
    width: 70,
    height: 70,
    transform: "translate(283.702 633)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ambiente_lavoro",
    "data-name": "ambiente lavoro",
    transform: "translate(-102.702 -299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppo_di_maschere_29",
    "data-name": "Gruppo di maschere 29",
    transform: "translate(-181 -334)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "fondo",
    d: "M25.57,74.016C2.232,86.383-.045,34.5,3.708,27.4c12.148-16.948,24.552,1.447,33.886-6.18C51.945,9.483,67.032,9.035,70.109,23.826s-.2,48.362-20.981,44.858C34.375,66.2,25.57,74.016,25.57,74.016Z",
    transform: "translate(277.141 629.598) rotate(-8)",
    fill: "#dedbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ambiente_lavoro-2",
    "data-name": "ambiente lavoro",
    transform: "translate(22071.4 -19179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3247",
    "data-name": "Raggruppa 3247",
    transform: "translate(-21789.338 19823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3236",
    "data-name": "Raggruppa 3236",
    transform: "translate(11.402)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1716",
    "data-name": "Tracciato 1716",
    d: "M384.481,199H331.7a1.706,1.706,0,0,0-1.7,1.711v36.327a1.706,1.706,0,0,0,1.7,1.711h18.153v6.271h-.828a.865.865,0,0,0-.862.868v1.258h1.69v.744h16.475v-.744h1.69v-1.258a.865.865,0,0,0-.862-.868h-.779v-.054h-.053V238.75h18.157a1.706,1.706,0,0,0,1.7-1.711V200.711A1.706,1.706,0,0,0,384.481,199Z",
    transform: "translate(-330 -199)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_718",
    "data-name": "Rettangolo 718",
    width: 16.26,
    height: 9.589,
    transform: "translate(31.414 38.67)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3237",
    "data-name": "Raggruppa 3237",
    transform: "translate(31.362 38.253)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1717",
    "data-name": "Tracciato 1717",
    d: "M521.872,567.355h15.653c.189-.82.34-1.355.34-1.355H521.5S521.668,566.533,521.872,567.355Z",
    transform: "translate(-521.5 -566)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1718",
    "data-name": "Tracciato 1718",
    d: "M221.4,3h52.1a1.678,1.678,0,0,1,1.678,1.678V36.771H219.72V4.678A1.678,1.678,0,0,1,221.4,3Z",
    transform: "translate(-207.901 -2.687)",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1719",
    "data-name": "Tracciato 1719",
    d: "M387.773,531.212h-52.1A1.678,1.678,0,0,1,334,529.533V526h55.451v3.533A1.678,1.678,0,0,1,387.773,531.212Z",
    transform: "translate(-322.181 -491.916)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_181",
    "data-name": "Ellisse 181",
    cx: 0.938,
    cy: 0.938,
    r: 0.938,
    transform: "translate(38.606 35.752)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1720",
    "data-name": "Tracciato 1720",
    d: "M392.572,436h17.893a.852.852,0,0,1,.852.852v1.233h-19.6v-1.233A.852.852,0,0,1,392.572,436Z",
    transform: "translate(-361.973 -390.555)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3238",
    "data-name": "Raggruppa 3238",
    transform: "translate(22.346 7.413)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_719",
    "data-name": "Rettangolo 719",
    width: 34.397,
    height: 19.571,
    rx: 4.5,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_720",
    "data-name": "Rettangolo 720",
    width: 33.515,
    height: 19.175,
    rx: 4.5,
    transform: "translate(22.787 7.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3239",
    "data-name": "Raggruppa 3239",
    transform: "translate(32.123 10.31)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_721",
    "data-name": "Rettangolo 721",
    width: 3.694,
    height: 3.325,
    rx: 1.663,
    fill: "#03518c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_722",
    "data-name": "Rettangolo 722",
    width: 9.974,
    height: 0.369,
    rx: 0.184,
    transform: "translate(36.925 10.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_723",
    "data-name": "Rettangolo 723",
    width: 8.291,
    height: 0.369,
    rx: 0.184,
    transform: "translate(36.925 11.419)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3240",
    "data-name": "Raggruppa 3240",
    transform: "translate(32.123 15.482)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_724",
    "data-name": "Rettangolo 724",
    width: 3.694,
    height: 3.325,
    rx: 1.663,
    fill: "#03518c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_725",
    "data-name": "Rettangolo 725",
    width: 9.974,
    height: 0.369,
    rx: 0.184,
    transform: "translate(36.925 15.482)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_726",
    "data-name": "Rettangolo 726",
    width: 9.974,
    height: 0.369,
    rx: 0.184,
    transform: "translate(36.925 16.59)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3241",
    "data-name": "Raggruppa 3241",
    transform: "translate(32.123 20.654)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_727",
    "data-name": "Rettangolo 727",
    width: 3.694,
    height: 3.325,
    rx: 1.663,
    fill: "#03518c"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_728",
    "data-name": "Rettangolo 728",
    width: 9.974,
    height: 0.369,
    rx: 0.184,
    transform: "translate(36.925 20.654)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_729",
    "data-name": "Rettangolo 729",
    width: 10.041,
    height: 0.369,
    rx: 0.184,
    transform: "translate(36.925 21.762)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3242",
    "data-name": "Raggruppa 3242",
    transform: "translate(31.466 45.393)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_730",
    "data-name": "Rettangolo 730",
    width: 16.26,
    height: 0.313
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_731",
    "data-name": "Rettangolo 731",
    width: 66,
    height: 3.432,
    transform: "translate(4 47.488)",
    fill: "#0096cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3249",
    "data-name": "Raggruppa 3249",
    transform: "translate(56.303 26.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3245",
    "data-name": "Raggruppa 3245",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1735",
    "data-name": "Tracciato 1735",
    d: "M945.184,502.591l.013-.019q.04-.062.079-.13l.014-.025c.025-.042.049-.086.071-.13l.012-.022c.026-.051.051-.1.073-.154h0a3.056,3.056,0,0,0,.122-.325l.013-.043c.012-.04.023-.08.034-.121l.013-.057c.009-.036.016-.073.023-.11a.361.361,0,0,1,.012-.062c0-.021.012-.073.017-.11a.286.286,0,0,1,.008-.063.682.682,0,0,0,.01-.119V490.163h-1.8v-5.247h-2.2v5.247H940.18v-7.536h-2.2v7.536h-.828V481.55h-2.2v8.613H933V500.87a3.2,3.2,0,0,0,3.241,3.163h6.222a3.265,3.265,0,0,0,2.623-1.3h0Q945.134,502.66,945.184,502.591Z",
    transform: "translate(-933 -481.55)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_734",
    "data-name": "Rettangolo 734",
    width: 2.074,
    height: 12.962,
    transform: "translate(2.203 4.985)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_735",
    "data-name": "Rettangolo 735",
    width: 2.074,
    height: 4.277,
    transform: "translate(2.203 0.706)",
    fill: "#3ad29f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_736",
    "data-name": "Rettangolo 736",
    width: 2.074,
    height: 12.962,
    transform: "translate(5.052 6.022)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_737",
    "data-name": "Rettangolo 737",
    width: 2.074,
    height: 4.277,
    transform: "translate(5.052 1.746)",
    fill: "#4d8af0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_738",
    "data-name": "Rettangolo 738",
    width: 2.074,
    height: 12.962,
    transform: "translate(8.555 8.225)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_739",
    "data-name": "Rettangolo 739",
    width: 2.074,
    height: 4.277,
    transform: "translate(8.555 3.949)",
    fill: "#f55f44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1736",
    "data-name": "Tracciato 1736",
    d: "M821.72,352h11.925v10.3a3.046,3.046,0,0,1-3.046,3.046h-5.833a3.046,3.046,0,0,1-3.046-3.046Z",
    transform: "translate(-821.331 -342.995)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3246",
    "data-name": "Raggruppa 3246",
    transform: "translate(0.386 9.005)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1737",
    "data-name": "Tracciato 1737",
    d: "M936,551v.518h11.406v10.3a3.032,3.032,0,0,1-.648,1.878,3.039,3.039,0,0,0,1.167-2.4V551Z",
    transform: "translate(-936 -551)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pianta",
    transform: "translate(4.615 17.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pianta-2",
    "data-name": "pianta",
    transform: "translate(-0.976 -10.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1722",
    "data-name": "Tracciato 1722",
    d: "M213.334,427.437s-2.751-12.859,3.33-29.437",
    transform: "translate(-202.145 -395.825)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1723",
    "data-name": "Tracciato 1723",
    d: "M134.7,563h12.194s2.406,5.732-1.327,14.254h-9.622A19.658,19.658,0,0,1,134.7,563Z",
    transform: "translate(-130.947 -535.264)",
    fill: "#03518c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1724",
    "data-name": "Tracciato 1724",
    d: "M233.28,387a6.244,6.244,0,0,1,7.183-2.789s-4.189,7.632-7.963,5.133Z",
    transform: "translate(-219.063 -383.971)",
    fill: "#5ae531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1725",
    "data-name": "Tracciato 1725",
    d: "M202.863,402.7a5.8,5.8,0,0,0-4.363-5.2s.434,8.986,3.765,7.514Z",
    transform: "translate(-189.988 -395.405)",
    fill: "#5ae531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1726",
    "data-name": "Tracciato 1726",
    d: "M216.944,436.676s.775-4.316,8.883-6.176c0,0-2.586,8.927-9.256,8.569Z",
    transform: "translate(-205.441 -423.29)",
    fill: "#5ae531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1727",
    "data-name": "Tracciato 1727",
    d: "M180.337,454.2s.853-4.513-4.215-8.7c0,0-5.5,10.019,3.979,11.9Z",
    transform: "translate(-169.493 -435.968)",
    fill: "#5ae531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1728",
    "data-name": "Tracciato 1728",
    d: "M213.476,500.118s-.588-6.379,5.783-7.618c0,0-2.327,8.907-5.792,10.5Z",
    transform: "translate(-202.782 -475.686)",
    fill: "#5ae531"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1729",
    "data-name": "Tracciato 1729",
    d: "M233,390.268s5.5-4.493,7.819-5.268",
    transform: "translate(-219.492 -384.841)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1730",
    "data-name": "Tracciato 1730",
    d: "M216.5,439.021s6.66-7.592,9.267-8.521",
    transform: "translate(-205.382 -423.29)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1731",
    "data-name": "Tracciato 1731",
    d: "M198.5,397.5s4.054,5.887,3.765,7.437",
    transform: "translate(-189.988 -395.405)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1732",
    "data-name": "Tracciato 1732",
    d: "M185.5,445.5s2.172,10.535,3.909,11.93",
    transform: "translate(-178.868 -435.968)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1733",
    "data-name": "Tracciato 1733",
    d: "M213.5,503.035s3.475-10.226,5.792-10.535",
    transform: "translate(-202.814 -475.686)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3244",
    "data-name": "Raggruppa 3244",
    transform: "translate(3.222 17.602)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1734",
    "data-name": "Tracciato 1734",
    d: "M153.866,563H142.08c-.026.1-.052.207-.08.308h11.465s2.268,5.569-1.155,13.881h.273C156.191,568.706,153.866,563,153.866,563Z",
    transform: "translate(-142 -563)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkEnvironment);
export default __webpack_public_path__ + "static/media/work_environment.8675ae42567e9d9da05a8d9c903d986e.svg";
export { ForwardRef as ReactComponent };